import AppHeader from '../AppHeader'
export default {
  name: 'request-holiday-new',
  created () {
    this.initialization()
    var today = new Date()
    this.nextMonth = today.getMonth() + 2
    this.thisMonth = today.getMonth() + 1
    if(this.nextMonth === 13){
      this.nextYear = today.getFullYear() + 1
      this.nextMonth = 1
    }else{
      this.nextYear = today.getFullYear()
    }

    this.search()
  },
  data () {
    return {
      localRequestHolidays: [
        {
          request_date: null,
          content: ''
        },
        {
          request_date: null,
          content: ''
        }
      ],
      localShifts: null,
      savingFlag: false,
      modalFlag: false,
      datePickerFlag: false,
      datePickerTargetIndex: null,
      nextMonth: null,
      thisMonth: null,
      nextYear: null,
      nextMonthCalender: null,
      requestHolidaysHaveOnlyNull: true,
      searchCallbackFlag: false,
      getCallbackFlag: false
    }
  },
  computed: {
    shift_dates() {
      return this.$store.getters.shift_dates
    },
    existRequestHolidayNotice() {
      return this.$store.getters.existRequestHolidayNotice
    }
  },
  components: {
    AppHeader
  },
  methods: {
    initialization: function () {
      var data = {
        'user_id': window.localStorage.getItem('user_id')
      }
      var self = this
      var callback = function() {
        var hiduke = new Date()
        var day = hiduke.getDate()
        if (self.existRequestHolidayNotice === 0) {
          if (day >= 16) {
            self.$router.push({ path: '/request_holiday_sent'})
          } else {
            self.getRequestHoliday()
          } 
        } else {
          self.getCallbackFlag = true
        }
      }
      this.$store.dispatch('EXIST_REQUEST_HOLIDAY_NOTICE', { data: data, callback: callback })
    },
    search: function() {
      var self = this

      var days_row_count = 6
      var days_column_count = 7
      this.localShifts = new Array(days_row_count)
      for (var i = 0; i < days_row_count; i++) {
        this.localShifts[i] = new Array(days_column_count)
      }

      var year = this.nextYear
      var month = this.nextMonth
      this.thisDate = new Date(year, month - 1, 1)
      this.searchCallbackFlag = false

      var data = {
        'user_id': window.localStorage.getItem('user_id'),
        'shop_id': window.localStorage.getItem('shop_id'),
        'target_date': this.formatDate(year, month)
      }
      var callback
      callback = function() {
        var length = Object.keys(self.shift_dates).length //何日あるか
        if (length > 0) {
          var first_key = Object.keys(self.shift_dates)[0]
          var week = self.shift_dates[first_key]['week']
          var start_index = self.getStartIndex(week) //月初の曜日のインデックス
          var column_index = start_index
          var row_index = 0
          for (var i = 0; i < length; i++) {
            var key = Object.keys(self.shift_dates)[i] //yyyy-mm-dd
            var obj = self.shift_dates[key] //{is_holiday:bool, week:""}

            if (column_index > 6) {
              column_index = 0
              row_index++
            }
            var data = {
                shift_date: key,
                is_holiday: obj['is_holiday'],
                week: obj['week']
            }
            self.localShifts[row_index][column_index] = data
            column_index++
          }
          self.searchCallbackFlag = true

          self.$forceUpdate()
        }
      }
      this.$store.dispatch('SHIFT_LIST_SEARCH',  {data: data, callback: callback})
    },
    getRequestHoliday: function() {
      var data = {}
      var self = this
      var callback = function(data) {
        self.localRequestHolidays = []
        for (var i = 0; i < data.length; i++) {
          let request_holiday = {
            request_date: data[i].request_date,
            content: data[i].content
          }
          self.localRequestHolidays.push(request_holiday)
        }
        self.getCallbackFlag = true
      }
      this.$store.dispatch('GET_REQUEST_HOLIDAY',  {data: data, callback: callback})
    },
    formatDate: function(year, month) {
      if (!year) year = (new Date()).getFullYear()
      if (!month) month = (new Date()).getMonth() + 1
      return year + '-' + ('00' + month).slice(-2) + '-01'
    },
    pullOutYear: function(data) {
      var day = new Date(data)
      return day.getFullYear()
    },
    pullOutDate: function(data) {
      var day = new Date(data)
      return day.getDate()
    },
    pullOutMonth: function(data) {
      var day = new Date(data)
      return day.getMonth() + 1
    },
    pullOutDay: function(data) {
      var day = new Date(data)
      var week = day.getDay()
      if (week === 1) return '月'
      if (week === 2) return '火'
      if (week === 3) return '水'
      if (week === 4) return '木'
      if (week === 5) return '金'
      if (week === 6) return '土'
      if (week === 0) return '日'
    },
    getStartIndex: function(week) {
      var start
      if (week === '月') start = 0
      if (week === '火') start = 1
      if (week === '水') start = 2
      if (week === '木') start = 3
      if (week === '金') start = 4
      if (week === '土') start = 5
      if (week === '日') start = 6
      return start
    },
    addRequestHolidays: function(index) {
      var request_holiday = {
        request_date: null,
        content: ''
      }
      this.localRequestHolidays.push(request_holiday)
    },
    deleteRequestHolidays: function(object) {
      console.log(object)
      this.localRequestHolidays = this.localRequestHolidays.filter(function(v){
        return v !== object;
      })
    },
    setDatePickerTarget: function(index) {
      this.datePickerFlag = true
      this.datePickerTargetIndex = index
    },
    setRequestDate: function(object) {
      for(let key in this.localRequestHolidays){
        let request_date = this.localRequestHolidays[key]['request_date']
        if(object === request_date){
          return false
        }
      }
      var index = this.datePickerTargetIndex
      this.localRequestHolidays[index]['request_date'] = object
      this.datePickerFlag = false
      this.datePickerTargetIndex = null
    },
    setSelected: function(target) {
      for(let key in this.localRequestHolidays){
        let request_date = this.localRequestHolidays[key]['request_date']
        if(target === request_date){
          return '-selected'
        }
      }
    },
    checkRequestHolidaysHaveOnlyNull() {
      let n = 0
      for(let localRequestHoliday of this.localRequestHolidays){
        if(localRequestHoliday['request_date'] !== null){
          n++
        }
      }
      if(n > 0){
        this.requestHolidaysHaveOnlyNull = false
      }else{
        this.requestHolidaysHaveOnlyNull = true
      }
    },
    openConfirmModal: function() {
      this.checkRequestHolidaysHaveOnlyNull()
      this.modalFlag = true
    },
    onClickSave: function() {
      if (this.savingFlag) return false
      this.savingFlag = true
      var data = {
        'user_id': window.localStorage.getItem('user_id'),
        'shop_id': window.localStorage.getItem('shop_id'),
        'request_holidays': this.localRequestHolidays
      }
      this.$store.dispatch('REQUEST_HOLIDAY_CREATE',
        { data: data, callback: this.onSaved })
    },
    onSaved: function(result) {
      this.savingFlag = false
      this.$router.push('/request_holiday_sent')
    },
    goTop: function() {
      this.$router.push({ path: '/'})
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/request-holiday-new.js